export default __webpack_public_path__ + "static/media/w-vinciworks.9e4e1aab.svg";